const apiConfig = {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://api.example.com',
    defaultHeaders: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };
  
  export default apiConfig;